namespace advisorop.components.investor {

    class InvRtgDashboardController {

        $router;
        public rtgId: number;
        rtg: domains.IAccountGroup;
        showClosedInactive: boolean = false;
        hideSleeves: boolean = true;

        performanceDetailsPtp: any[]; // performance detail for P2P datagrid
        ptpCaption: string = "Please choose a date range and click Apply";
        ptpLineCaption: string = null;
        // inputs for account summary grid
        public accounts: any[];
        annuityAccounts = [];
        public noPerformanceAccounts: any[];
        noAssetAllocHistAccounts;
        public accountGroupType: domains.AccountGroupType = domains.AccountGroupType.RTG;
        mvDate: Date = null;
        perfDate: Date = null;
        public accountsWithHoldingsInfo: any[];
        showAssetAllocation = 1;
        public chartData: Array<domains.IChartDataSource>;
        chrData: Array<domains.IChartDataSource> = [];
        // For investors, historical charts is enabled per investor
        invLoginOptionAllowHistChartsGroups: boolean = false;
        invLoginOptionAllowHistChartsAccts: boolean = false;
        allowHistCharts: boolean = false;
        histChartView: boolean = false;
        histChrData = [];
        histChartData = []
        histChartType: string = "1";
        histChartDateType: string = "1";
        chartHDAccountsController: advisorop.components.widgets.ChartHdAccountsController;
        asg: InvAccountSummaryGridController;

        // PP Access
        //ppParams: { pplevel: string, ppclientid: string }; // ppclientid: 4918    U-DEMO04   DEMO01 | pplevel:  HH CG AC

        public investor: domains.IInvestor;
        public showPointToPoint: boolean = false;
        public dg: DevExpress.ui.dxDataGridOptions;
        hdg: DevExpress.ui.dxDataGridOptions;
        fromDate: Date;
        toDate: Date;
        public activeTab: number = 1;
        public LoadingP2PPerformanceLadda: boolean = false;

        chartDataParams: {
            level?: string,
            householdId?: number,
            accountGroupType?: number,
            groupId?: number,
            accountId?: number,
            boModelId?: number,
            showClosedInactive?: boolean,
            additionalData?: string
        }

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#invRtgContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        chartDataLoading: boolean = false;
        chartLoadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#invRtgChartContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Retrieving data...",
            bindingOptions: {
                visible: "vm.chartDataLoading"
            }
        }

        ctlAccountDdl: advisorop.components.common.AccountsDdlController;

        static $inject = ["investorService", "accountGroupApi", "householdApi", `acgHelper`, "investorDashboardService", "generalService"];
        constructor(private invSrv: services.InvestorService,
            private acgApi: services.AccountGroupApi,
            private hhApi: services.HouseholdApi,
            private acgs: services.AcgHelper,
            private ids: services.InvestorDashboardService,
            private gs: services.GeneralService) {
            this.chartData = this.ids.getEmptyChartData();
            this.histChartData = [];
            this.chartDataParams = {
                level: null,
                householdId: null,
                accountGroupType: null,
                groupId: null,
                accountId: null,
                boModelId: null,
                showClosedInactive: null,
                additionalData: null
            };
            this.dg = {
                export: {
                    enabled: false,
                    fileName: "noPerformanceAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.noPerformanceAccounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "There are no manual accounts",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountName', caption: 'Account name', cellTemplate: 'colFullName' }
                ]
            };
            this.hdg = {
                export: {
                    enabled: false,
                    fileName: "NoAssetAllocHistAccounts"
                },
                bindingOptions: {
                    dataSource: "vm.noAssetAllocHistAccounts"
                },
                //height: "350px",
                paging: {
                    pageSize: 20,
                    enabled: true
                },
                scrolling: {
                    mode: "infinite",
                    useNative: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "There are no accounts",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'accountName', caption: 'Account name', cellTemplate: 'colFullName2' }
                ]
            };
        }

        loadRtgCharts(): void {
            this.hhApi.getCharts(this.rtg.householdId, this.accountGroupType, "R", this.rtgId, null, null, this.showClosedInactive, this.hideSleeves, this.histChartView)
                .then((data) => {
                    if (!data || !data.data || !data.data.chartData || data.data.chartData.length <= 0) {
                        console.log("There are no charts ...");
                        // empty chart
                        this.chrData = this.ids.getEmptyChartData();
                        this.chartData = this.chrData;
                        return;
                    }
                    this.chrData = data.data.chartData;

                    this.chrData.map(v => v.chart.caption = this.chartDataParams.additionalData);

                    this.chartData = this.chrData;
                });
        };

        // Updates the structure in place
        setVisibilityOfData(dataSet: Array<domains.IStackedBarChartDataset>, histChartType: string) {
            if (histChartType == "1" || histChartType == "2") {
                // percentage or value based = show all
                dataSet.forEach(function (r, a) {
                    if (r)
                        r.visible = "1";
                });
            } else if (histChartType == "3") {
                // Hide Value Line
                dataSet.forEach(function (r, a) {
                    if (r) {
                        if (r.seriesname == "Total Value")
                            r.visible = "0";
                        else
                            r.visible = "1";
                    }
                });
            } else if (histChartType == "4") {
                // Show Value Line Only
                dataSet.forEach(function (r, a) {
                    if (r) {
                        if (r.seriesname == "Total Value")
                            r.visible = "1";
                        else
                            r.visible = "0";
                    }
                });
            }
        }

        toggleDataVisibility() {
            // show or hide the line chart data based on the options selected by the user. 
            this.histChrData.forEach(v => { if (v.dataset && v.dataset.length > 0) this.setVisibilityOfData(v.dataset, this.histChartType); });
        }

        setStackPercentAttribute() {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.setChartAttributes(this.histChartType);
            }
        }

        // Sum across like indexes for each series to compute the total for each series and
        // return the line-chart series definition that we can append to the chart dataset structure.
        createLineChartDataset(dataSet: Array<domains.IStackedBarChartDataset>): domains.IStackedBarChartDataset {

            // Initialize an empty chart dataset data structure
            let chartDatasetData: Array<domains.ChartDatasetData> = [];
            if (dataSet && dataSet.length > 0 && dataSet[0].data && dataSet[0].data.length > 0) {
                dataSet[0].data.forEach(f => {
                    var d: domains.ChartDatasetData = { value: 0 };
                    chartDatasetData.push(d);
                });
                // Populate the structure, summing across all of the series
                dataSet.forEach(function (r, a) {
                    r.data.forEach(function (b, i) {
                        chartDatasetData[i].value = (chartDatasetData[i]?.value || 0) + b.value;
                    });
                });
                // Return dataset, specified as line plot
                const ret: domains.IStackedBarChartDataset = {
                    seriesname: "Total Value",
                    renderas: "Line",
                    showvalues: "1",
                    data: chartDatasetData
                };

                return ret;
            }
            return null;
        }

        updateHistChartData() {
            if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                this.histChartData = [];
                //console.log("HISTCHRDATA", this.histChrData);
                angular.copy(this.histChrData, this.histChartData);
            }
        }

        bindChartHDAccountsWidget(ctrl: advisorop.components.widgets.ChartHdAccountsController) {
            this.chartHDAccountsController = ctrl;
            this.setStackPercentAttribute();
        }

        loadSelectedChartData() {

            this.chartDataLoading = true;

            var dateTypeParam: domains.HistChartDateType;
            if (this.histChartDateType == "1")
                dateTypeParam = domains.HistChartDateType.LAST_SIX_MONTHS;
            else if (this.histChartDateType == "2")
                dateTypeParam = domains.HistChartDateType.LAST_FOUR_QUARTERS;
            else
                dateTypeParam = domains.HistChartDateType.LAST_ONE_WEEK;

            //const getHdChartPromise = this.ids.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, this.histChartView, dateTypeParam);
            //
            //// load HD chart data 
            //if (getHdChartPromise != null) {
            //    getHdChartPromise.then(response => {
            if (this.chartHDAccountsController) {
                this.chartHDAccountsController.clearHistChartData = true;
                this.histChartData = [];
            }
            this.ids.getHdChartPromise(this.chartDataParams.level, this.chartDataParams.householdId, this.chartDataParams.accountGroupType, this.chartDataParams.groupId, this.chartDataParams.accountId, this.chartDataParams.boModelId, this.chartDataParams.showClosedInactive, (this.histChartView && this.allowHistCharts), dateTypeParam)
                .then(response => {
                    if (!response || !response.data || !response.data.chartData || response.data.chartData.length <= 0) {
                        this.hideAssetAllocationPanelAndEmptyData();
                    } else {
                        this.updateChartData(response, this.chartDataParams.additionalData);
                    }
                }).finally(() => {
                    this.chartDataLoading = false;
                });
        }

        hideAssetAllocationPanelAndEmptyData = () => {
            console.log("There are no charts...");
            this.showAssetAllocation = 0;
            this.ctlAccountDdl.selItemID = "no data";
            this.ctlAccountDdl.selItemData = null;
            this.chartData = this.ids.getEmptyChartData();
        }

        updateChartData = (response: ng.IHttpPromiseCallbackArg<any>, additionalData) => {
            if (!response || !response.data || !response.data.chartData || response.data.chartData.length <= 0) {
                this.hideAssetAllocationPanelAndEmptyData();
                return;
            }
            this.showAssetAllocation = 1;
            this.chrData = response.data.chartData;
            this.chrData.map(v => v.chart.caption = additionalData);
            this.chartData = this.chrData;
            if (this.histChartView && this.allowHistCharts) {
                this.histChrData = response.data.histChartData;
                if (this.histChrData && this.histChrData.length > 0 && this.histChrData[0].dataset.length > 0) {
                    // Create line chart dataset for the totals
                    this.histChrData.forEach(v => v.dataset?.push(this.createLineChartDataset(v.dataset)));
                    if (this.chartHDAccountsController)
                        this.chartHDAccountsController.histChartDataExists = true;
                    this.toggleDataVisibility();
                    this.updateHistChartData();
                } else {
                    if (this.chartHDAccountsController)
                        this.chartHDAccountsController.histChartDataExists = false;
                }
            }
        }

        histChartsToggle(toggle: boolean) {

            // Check if user is allowed to see historical charts for this level
            if (this.chartDataParams && ((this.invLoginOptionAllowHistChartsGroups && this.chartDataParams.level == "R")
                || (this.invLoginOptionAllowHistChartsAccts && (this.chartDataParams.level == "A" || this.chartDataParams.level == "S")))) {
                // Hist charts are allowed
                this.allowHistCharts = true;
            } else {
                // Hist charts are not allowed, do not show
                this.allowHistCharts = false;
            }
        }

        hg_onItemSelected(item, level, additionalData) {

            if (!this.rtg) {
                //console.log(`hg_onItemSelected: Rtg not loaded.`);
                return;
            }

            if (!this.ctlAccountDdl) {
                //console.log(`hg_onItemSelected: AccountDll has not been initialised yet...`);
                return;
            }

            // when account is changed we need to calculate PpLevel and PpClientId, which we needs for a PP reports
            //this.ppParams = this.ids.calculatePpLevelAndClientId(level, item.boRtgId, item.boCustodialAccountNumber, item.boUMAAccountIdentifierString);

            this.chartDataParams.level = level;
            this.chartDataParams.householdId = this.rtg.householdId;
            this.chartDataParams.accountGroupType = this.accountGroupType;
            this.chartDataParams.groupId = item.groupId;
            this.chartDataParams.accountId = item.accountId;
            this.chartDataParams.boModelId = item.boModelId;
            this.chartDataParams.showClosedInactive = this.showClosedInactive;
            this.chartDataParams.additionalData = additionalData;

            if (level == "R") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}`);
                this.histChartsToggle(true);
            }
            else if (level == "A") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }
            else if (level == "S") {
                this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
                //if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && item.manualHoldingsExSystem == true)
                //    this.hideAssetAllocationPanelAndEmptyData();
                if (item.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT)
                    this.histChartsToggle(false);
                else
                    this.histChartsToggle(true);
            }

            this.loadSelectedChartData();

            //else {
            //    // OA - outside investment accounts where holdings are maintained outside of AdvisorOp,
            //    // we can not show asset allocation for these because they all share the same Security ID
            //    this.hideAssetAllocationPanelAndEmptyData();
            //    if (item.boModelId > 0) {
            //        this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}_${item.boModelId}`);
            //    } else {
            //        this.ctlAccountDdl.setSelItemId(`${item.groupId}_${item.accountId}`);
            //    }
            //}
        }

        $onInit(): void {
            // default from-date to 2 days ago
            this.fromDate = new Date();
            this.fromDate.setDate(this.fromDate.getDate() - 2);
            // default to-date to yesterday
            this.toDate = new Date();
            this.toDate.setDate(this.toDate.getDate() - 1);
            this.loadInvestor();
        }

        loadAccounts(): void {
            this.mvDate = null;
            this.isInitializing = true;
            this.acgApi.getAccounts(this.rtgId, this.showClosedInactive).then((data) => {
                this.accounts = data.data.gridData;

                this.annuityAccounts = [];
                if (data.data.hasOwnProperty('annuityAccounts') && data.data.annuityAccounts.length > 0)
                    this.annuityAccounts = data.data.annuityAccounts;

                this.isInitializing = false;
                // preparing data structure for DropDown-TreeView content
                if (this.ctlAccountDdl) {
                    //console.log(`Preparing data for DDL...`);
                    this.ctlAccountDdl.prepareDropDownData(this.accounts, this.hideSleeves);
                    this.ctlAccountDdl.setSelItemId(`${this.rtgId}`);
                }

                if (this.accounts.length > 0) {
                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    this.mvDate = this.accounts[0].marketValueDate;
                }
                this.noPerformanceAccounts = this.accounts.filter(f => f.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && f.manualHoldingsExSystem === false);
                this.noAssetAllocHistAccounts = this.accounts.filter(f => f.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT && f.manualHoldingsExSystem == false);
                //console.log("accounts", this.accounts);
                //console.log("noPerformanceAccounts", this.noPerformanceAccounts);
                //console.log("noAssetAllocHistAccounts", this.noAssetAllocHistAccounts);
            }, err => this.isInitializing = false);
        };

        loadRtg(): void {
            this.perfDate = null;
            this.isInitializing = true;
            this.acgApi.getPerformanceDetails(this.rtgId)
                .then((data) => {
                    this.rtg = data.data;
                    this.isInitializing = false;

                    if (this.rtg.performanceDetails.length > 0) {
                        this.perfDate = this.rtg.performanceDetails[0].asOfDate;
                    }

                    // Initialize the current state so that if the user elects to see historical charts
                    // we can load them using the current state
                    this.chartDataParams.level = "R";
                    this.chartDataParams.householdId = this.rtg.householdId;
                    this.chartDataParams.accountGroupType = this.accountGroupType;
                    this.chartDataParams.groupId = this.rtgId;
                    this.chartDataParams.accountId = null;
                    this.chartDataParams.boModelId = null;
                    this.chartDataParams.showClosedInactive = this.showClosedInactive;
                    this.chartDataParams.additionalData = this.rtg.accountGroupDescription + " - Account Group";


                    //console.log(this.rtg);
                    this.loadRtgCharts();
                }, err => this.isInitializing = false)
                .catch((reason) => {
                    console.log("Error during loading of RTG Performance Details");
                    console.log(reason);
                });
        }

        loadP2PPerformanceDetails = () => {
            if (this.fromDate == null || this.fromDate == undefined || this.toDate == null || this.toDate == undefined) {
                toastr.error("Date can not be blank.");
                return;
            }

            this.LoadingP2PPerformanceLadda = true;
            //console.log(`Loading P2P data for date range: ${this.fromDate} - ${this.toDate}`);

            var utcFromDate: Date = new Date(Date.UTC(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate()));
            var utcToDate: Date = new Date(Date.UTC(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate()));

            this.invSrv.getRtgPerformanceDetailsP2P(this.rtgId, utcFromDate, utcToDate)
                .then(response => {
                    this.performanceDetailsPtp = response.data;
                    var fdat = (this.fromDate.getMonth()) + 1 + "-" + this.fromDate.getDate() + "-" + this.fromDate.getFullYear();
                    var tdat = (this.toDate.getMonth()) + 1 + "-" + this.toDate.getDate() + "-" + this.toDate.getFullYear();
                    this.ptpCaption = "Performance from " + fdat + " to " + tdat;
                    this.ptpLineCaption = "Cumulative " + this.ptpCaption; this
                    //console.log("RESPONSEDATA: ", response.data);
                }, err => this.gs.showError(err)).finally(() => {
                    this.LoadingP2PPerformanceLadda = false;
                });

            return;
        }

        asg_onReady = (component) => {
            //console.log("onReady", component);
            this.asg = component;
        }

        onAccountsDdlItemSelected = (itemData) => {
            // console.log("onAccountsDdlItemSelected received...", itemData)

            if (itemData) {
                // clear selection in HH grid
                $("#dgHouseholds tr.acsrow").each((ind, elm) => {
                    $(elm).removeClass("acsrow");
                });

                // selecting row in dgHouseholds grid
                const dgSummary = DevExpress.ui.dxDataGrid.getInstance($("#dgHouseholds")) as DevExpress.ui.dxDataGrid;

                //SYNC selection on SummaryGrid
                this.acgs.syncDgSummaryGridSelection(itemData.level, itemData.item, this.asg.sortByField, this.asg.rootLevel, dgSummary, this.accounts);

                // console.log(`HH row index is:`, dgSummaryRowIndex);
                this.hg_onItemSelected(itemData.item, itemData.level, itemData.caption);
            }
        }

        onChangeHistView() {
            if (this.histChartView && !this.isInitializing)
                this.loadSelectedChartData();
        }

        onChangeHistChartType() {
            this.setStackPercentAttribute();
            this.toggleDataVisibility();
            this.updateHistChartData();
        }

        onChangeHistChartDateType() {
            this.loadSelectedChartData();
        }

        onAccountsDdlReady = (ctrl) => {
            this.ctlAccountDdl = ctrl;
        }

        loadInvestor() {
            this.invSrv.getInvestor().then(data => {
                this.investor = data.data;

                // Set investor login option to be able to view historical asset allocation charts at the group level
                if (this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_GROUPLEVEL).length > 0) {
                    this.invLoginOptionAllowHistChartsGroups = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_GROUPLEVEL)[0].value == 1;
                }
                // Set investor login option to be able to view historical asset allocation charts at the account level
                if (this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_ACCTLEVEL).length > 0) {
                    this.invLoginOptionAllowHistChartsAccts = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_HISTORICAL_ASSET_ALLOC_CHARTS_ACCTLEVEL)[0].value == 1;
                }
                // Initialize to whatever the group level permission is
                this.allowHistCharts = this.invLoginOptionAllowHistChartsGroups;

                if (this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_POINT_TO_POINT_PERFORMANCE).length > 0) {
                    this.showPointToPoint = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_POINT_TO_POINT_PERFORMANCE)[0].value == 1;
                }
            }, err => this.gs.showError(err));
        }

        $routerOnActivate(next, previous) {
            this.rtgId = <number>next.params.rtgId;

            this.loadRtg();

            this.loadAccounts();
        }
    }



    class InvRtgDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = InvRtgDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/investor-module/components/inv-rtg-dashboard.html';
        }
    }
    angular.module(Constants.APP).component("invRtgDashboard", new InvRtgDashboard());


}